import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { AnimationOnScroll } from "react-animation-on-scroll";
import BannerMenu from "src/component/BannerMenu";
const useStyles = makeStyles((theme) => ({
  bannerBox: {
    overflow: "hidden",
    position: "relative",
    backgroundSize: "cover",
    minheight: "100vh",
    padding: "160px 0px 70px",
    zIndex: "1",

    backgroundSize: "cover",
    backgroundColor: "#000",
    backgroundImage: "url(./images/banner/banner.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top right",
    [theme.breakpoints.down("md")]: { padding: "123px 0px 90px" },
    [theme.breakpoints.down("sm")]: {
      minHeight: "61vh",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "80px 0px 20px",
    },
    "& .gridBox1": {
      order: "1",
      [theme.breakpoints.down("xs")]: {
        order: "2",
        textAlign: "center",
      },
    },
    "& .gridBox2": {
      order: "2",
      [theme.breakpoints.down("xs")]: {
        order: "1",
        textAlign: "center",
      },
    },

    "& .textBox": {
      "& h4": {
        lineHeight: "33px",
      },
      "& p": {
        color: "rgba(255, 255, 255, 0.6)",
        fontSize: "14px",
        maxWidth: "483px",
      },
    },
  },
}));

export default function Banner() {
  const history = useHistory();
  const classes = useStyles();

  const handleClose = () => {};
  const [ShowTopBtn, setShowTopBtn] = useState();
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const handleclick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box className={classes.bannerBox}>
      <Container maxWidth="lg">
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={5} lg={6} sm={12} className="gridBox1">
            <Box className="textBox">
              <AnimationOnScroll animateIn="animate__bounce">
                <Typography variant="h1" color="primary">
                  FIERES
                </Typography>
              </AnimationOnScroll>
              <AnimationOnScroll animateIn="animate__bounce">
                <Typography variant="h4" color="primary">
                  Blockchain Redefined Simplifying Digital Asset Ownership with
                  the most scalable blockchain economy
                </Typography>
              </AnimationOnScroll>
              <Box mt={2} mb={3}>
                <AnimationOnScroll animateIn="animate__fadeInUp">
                  <Typography variant="body2">
                    Experience the unparalleled power of Fieres chain - the
                    trailblazing crypto engineering organisation transforming
                    the digital asset landscape. Our super-fast blockchain can
                    handle over 3500 transactions per second with Web 3.0
                    capabilities, metaverse integration, cutting-edge
                    technology, finance solutions, and Play 2 Earn gaming. Join
                    us in revolutionising the digital asset ecosystem and
                    discovering the most scalable blockchain economy.
                  </Typography>
                </AnimationOnScroll>
              </Box>

              <Button
                variant="contained"
                color="primary"
                // onClick={() => history.push("/coming-soon")}
                // href="/coming-soon"
                target="_blank"
                href="images/Fieres_Whitepaper.pdf"
              >
                White paper{" "}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={7} lg={6} sm={12} className="gridBox2">
            <Box className="bannerCircle"></Box>
            <BannerMenu />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
